import { Button } from 'antd';
import { useContext } from 'react';

import './VendorLeadStepLayoutNextButton.scss';

import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';

export function VendorLeadStepLayoutBackButton() {
  const { goBack, isEditing } = useContext(VendorsContext);

  return (
    <Button
      className="flex row nowrap align-items-center"
      type="primary"
      ghost={true}
      disabled={isEditing}
      onClick={goBack}
    >
      Back
    </Button>
  );
}
